// extracted by mini-css-extract-plugin
export var bodySections = "_50-8";
export var gray = "_50-7";
export var green = "_50-4";
export var iconContainer = "_50-9";
export var iconWidgetContainer = "_50-1";
export var phoneIcon = "_50-2";
export var red = "_50-5";
export var statusDot = "_50-3";
export var widgetContainer = "_50-0";
export var yellow = "_50-6";